export default {
  ETreeItemTypes: {
    REPOSITORY: 0,
    FOLDER: 1,
    DOCUMENT_TYPE: 2,
    ADDITIONAL_FIELD: 3,
    LOADING: 4,
    QUICK_ACCESS: 5,
    SHARED_DOCUMENTS: 6,
    PENDING_SCAN: 7,
    CHECKOUTS: 8,
    TRASH_CAN: 9,
    FAVORITES: 10,
    MY_DOCS_EXPIRED: 11,
    MY_ACTIVITY_EXPIRED: 12,
  },
};
